import { render, staticRenderFns } from "./ShutterRussianLanguageForm.vue?vue&type=template&id=783cf26c&scoped=true&lang=pug&"
import script from "./ShutterRussianLanguageForm.vue?vue&type=script&lang=js&"
export * from "./ShutterRussianLanguageForm.vue?vue&type=script&lang=js&"
import style0 from "./ShutterRussianLanguageForm.vue?vue&type=style&index=0&id=783cf26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783cf26c",
  null
  
)

export default component.exports